function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import _ from 'lodash';
// eslint-disable-next-line import/no-extraneous-dependencies
import { getAvailableQuantity } from 'shared/order/bogo/common';
var issueDiscountBundleRewards = function(bogoCalcsData, bogoSpecial, conditionsManager) {
    var discountBundle = bogoSpecial.discountBundle, specialId = bogoSpecial.specialId, source = bogoSpecial.source;
    var discountType = discountBundle.discountType, value = discountBundle.value;
    var rewardsSatisfiers = {};
    _.forEach(conditionsManager.satisfiers, function(param) {
        var item = param.item, quantity = param.quantity;
        var quantityToDiscount = quantity;
        // if we have a limit we want to use that as the quantityToDiscount for this pass
        // unless the limit is greater than the availableQuantity
        // if there is a leftover that doesn't divide evenly across the limit
        // we don't want to include that remainder quantity
        // limits are only available on POS specials per the field "per cart limit"
        if ((discountBundle === null || discountBundle === void 0 ? void 0 : discountBundle.limit) && source === 'POS') {
            var availableQuantity = getAvailableQuantity({
                item: item,
                bogoCalcsData: bogoCalcsData,
                pendingConditionsSatisfiers: {},
                pendingRewardsSatisfiers: rewardsSatisfiers,
                specialId: bogoSpecial.specialId
            });
            var lesserOfAvailableAndLimit = Math.min(availableQuantity, discountBundle === null || discountBundle === void 0 ? void 0 : discountBundle.limit);
            if (availableQuantity >= (discountBundle === null || discountBundle === void 0 ? void 0 : discountBundle.limit)) {
                quantityToDiscount = lesserOfAvailableAndLimit;
            } else {
                quantityToDiscount = lesserOfAvailableAndLimit % (discountBundle === null || discountBundle === void 0 ? void 0 : discountBundle.limit) === 0 ? lesserOfAvailableAndLimit : 0;
            }
        }
        if (quantityToDiscount > 0) {
            bogoCalcsData.ignoreConditionsForDiscountBundle = true;
            rewardsSatisfiers[item.key] = {
                item: item,
                quantity: quantityToDiscount,
                rewards: _define_property({}, discountBundle._id, {
                    quantity: quantityToDiscount,
                    reward: _define_property({
                        _id: discountBundle._id,
                        quantity: quantityToDiscount
                    }, discountType, value),
                    discountBundle: _object_spread({}, discountBundle),
                    specialId: specialId,
                    discountStacking: bogoSpecial.discountStacking,
                    discountPrecedence: bogoSpecial.discountPrecedence,
                    stackingBehavior: bogoSpecial.stackingBehavior,
                    nonStackingBehavior: bogoSpecial.nonStackingBehavior,
                    settingsDerivedFrom: bogoSpecial.settingsDerivedFrom
                })
            };
        }
    });
    return rewardsSatisfiers;
};
export default issueDiscountBundleRewards;
